import {
  EXPORT_RESPONSE_FAIL,
  EXPORT_RESPONSE_LOADING,
  EXPORT_RESPONSE_SUCCESS,
  RESPONSE_FAIL,
  RESPONSE_LOADING,
  RESPONSE_SUCCESS,
  OPEN_SEND_TO_WHATSAPP_MODAL,
  CLOSE_SEND_TO_WHATSAPP_MODAL,
} from '../types';

const initialState = {
  questions: [],
  responses: [],
  pageIndex: 0,
  totalResponseCount: 0,
  isLoading: false,
  isExportLoading: false,
  openSendToWhatsAppModal: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case RESPONSE_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case RESPONSE_SUCCESS:
      return {
        ...state,
        ...payload,
        isLoading: false,
      };
    case RESPONSE_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case EXPORT_RESPONSE_LOADING:
      return {
        ...state,
        isExportLoading: true,
      };
    case EXPORT_RESPONSE_SUCCESS:
    case EXPORT_RESPONSE_FAIL:
      return {
        ...state,
        isExportLoading: false,
      };
    case OPEN_SEND_TO_WHATSAPP_MODAL:
      return {
        ...state,
        openSendToWhatsAppModal: payload,
      };
    case CLOSE_SEND_TO_WHATSAPP_MODAL:
      return {
        ...state,
        openSendToWhatsAppModal: false,
      };
    default:
      return state;
  }
}
